import { inject, Injectable } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { KeywordValue } from 'src/app/models/keyword';

@Injectable({
  providedIn: 'root'
})
export class KeywordAddFormFactory {
  formBuilder = inject(UntypedFormBuilder);

  build(keywordValue?: KeywordValue): UntypedFormGroup {
    return this.formBuilder.group({
      id: new FormControl(keywordValue?.id ?? ''),
      keywordValueName: new FormControl(keywordValue?.keywordValueName ?? '', [Validators.required]),
      description: new FormControl(keywordValue?.description ?? '')
    });
  }
}
